<template>
  <div id="loader"></div>

  <div class="col-md-12 text-center">
      <img
      class="img-fluid mt-4"
      id="logo"
      alt="rtplogo"
      src="https://dev-checkin.veinspracticesolution.com/assets/images/rtplogo.png"
      width="100"
    />
    <img
      class="img-fluid mt-4"
      id="logo"
      alt="rtplogo"
      src="https://dev-checkin.veinspracticesolution.com/assets/images/authorize.gif"
      width="100"
    />
  </div>
  <section
    v-show="paymentDue"
    id="step-0"
    class="section active m-b-40"
    style="margin-top: 70px"
  >
    <div class="container form-container slide">
      <div class="col-12" id="strips1">
        <h4 class="font-weight-bold my-3 text-center">Payment Due</h4>
      </div>
      <table class="table table-striped">
        <tbody>
          <tr>
            <th class="font-weight-bold">Patient Name</th>
            <td id="td1">{{ PaymentRequest.Name }}</td>
          </tr>
          <tr>
            <th class="font-weight-bold">Date Of Birth</th>
            <td id="td1">{{ PaymentRequest.DOB }}</td>
          </tr>
          <tr>
            <th class="font-weight-bold">Date of Service</th>
            <td id="td1">{{ PaymentRequest.DOS }}</td>
          </tr>
          <tr>
            <th class="font-weight-bold">Sent By</th>
            <td id="td1">{{ PaymentRequest.SentBy }}</td>
          </tr>
          <tr>
            <th class="font-weight-bold">Sent Date</th>
            <td id="td1">{{ PaymentRequest.SentDate }}</td>
          </tr>
          <tr>
            <th class="font-weight-bold">Amount</th>
            <td id="td1">{{ PaymentRequest.Amount }}</td>
          </tr>
          <tr>
            <th class="font-weight-bold">Notes:</th>
            <td id="td1">{{PaymentRequest.Notes}}</td>
          </tr>
          <tr v-if="PaymentRequest.Attacments != ''">
            <th class="font-weight-bold">Attachments:</th>
            <td id="td1">
              <a :href="PaymentRequest.Attacments" class="btn btn-sm btn-outline-success">
                Download Attachment
              </a>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="row">
        <div class="card col" id="backbtncard">
          <a href="javascript:void(0)">
            <img
              src="https://dev-checkin.veinspracticesolution.com/assets/images/buttons/ba.png"
              alt=""
              v-show="false"
              class="img-fluid btn-start"
              id="backbtn"
            />
            <img
              :src="'https://dev-checkin.veinspracticesolution.com/assets/images/buttons/bahover.png'"
              alt=""
              class="img-fluid btn-start img-top"
              v-show="false"
              id="backbtn"
            />
          </a>
        </div>

        <div class="card col" id="nextbtncard">
          <a href="javascript:void(0)">
            <img
              src="https://dev-checkin.veinspracticesolution.com/assets/images/buttons/pi.png"
              alt=""
              v-show="nextBtn"
              class="img-fluid btn-start"
              id="nextbtn"
            />
            <img
              src="https://dev-checkin.veinspracticesolution.com/assets/images/buttons/pihover.png"
              alt=""
              @click="NextClick()"
              v-show="nextBtn"
              class="img-fluid btn-start img-top"
              id="nextbtn"
            />
          </a>
        </div>
      </div>
    </div>
  </section>

  <section
    v-show="paymentReceipt"
    id="step-1"
    class="section active m-b-40"
    style="margin-top: 70px"
  >
    <div class="container form-container">
      <div class="col-12" id="strips1">
        <h4 class="font-weight-bold my-3 text-center">Payment Receipt</h4>
      </div>
      <p><small class="mb-5">Please enter information below.</small></p>

      <form class="floating-labels">
        <!-- first row -->
        <div class="row">
          <div class="col-lg-12">
            <div class="form-group focused m-b-40">
              <input
                v-model="CreditCardInfo.cardHolderName"
                type="text"
                class="form-control required"
                id="filler_name"
                name="filler_name"
                maxlength="200"
              />
              <label for="float-label" class="float-label-left"
                >Card Holder Name</label
              >
            </div>
          </div>
          <div class="col-lg-12">
            <!-- last name -->
            <div class="form-group m-b-40">
              <input
                v-model="CreditCardInfo.cardNumber"
                type="text"
                class="form-control required"
                id="cc"
                v-mask="'####-####-####-####'"
                onkeypress="return checkDigit(event)"
              /><span class="bar"></span>

              <label for="" class="fload float-label-left">Card Number</label>
            </div>
            <!-- last name -->
          </div>
        </div>
        <!-- first row -->

        <!-- second row -->
        <div class="row">
          <div class="col-lg-12">
            <div class="form-group focused m-b-40">
              <input
                type="number"
                v-model="CreditCardInfo.cardcvc"
                class="form-control required"
                v-mask="'####'"
                id="filler_name"
                name="filler_name"
              />
              <label for="float-label" class="float-label-left">Card CVC</label>
            </div>
          </div>
          <div class="col-lg-12">
            <div class="form-group focused m-b-40">
              <h6
                class="font-weight-bold float-label-left"
                style="padding-right: 310px"
              >
                Card Expiry:
              </h6>
              <input
                v-model="CreditCardInfo.expiryDate"
                type="month"
                class="form-control required"
                id="filler_name"
                name="filler_name"
              />
            </div>
          </div>
          <div class="col-lg-12">
            <!-- last name -->
            <div class="form-group m-b-40">
              <input
                v-model="CreditCardInfo.zip"
                type="text"
                class="form-control required"
                id=""
                placeholder=""
              /><span class="bar"></span>
              <label for="" class="float-label-left">Zip</label>
            </div>
            <!-- last name -->
          </div>
        </div>
        <!-- second row -->

        <!-- Third row -->
        <div class="row">
          <div class="col-lg-12">
            <div class="form-group focused m-b-40">
              <input
                v-model="PaymentRequest.Amount"
                disabled
                type="text"
                class="form-control required"
                id="filler_name"
                name="filler_name"
              />
              <label for="float-label" class="float-label-left">Amount</label>
            </div>
          </div>
          <div class="col-lg-12">
            <!-- last name -->
            <div class="form-group">
              <label for=" " class="control-label float-label-left"
                >Comment:</label
              >
              <textarea
                v-model="CreditCardInfo.comment"
                class="form-control"
                id=""
              ></textarea>
            </div>
            <!-- last name -->
          </div>
        </div>
        <!-- Third row -->
      </form>

      <div class="row">
        <div class="card col" id="backbtncard">
          <a href="javascript:void(0)">
            <img
              src="https://dev-checkin.veinspracticesolution.com/assets/images/buttons/ba.png"
              alt=""
              class="img-fluid btn-start"
              id="backbtn"
            />
            <img
              @click="BackClick()"
              src="https://dev-checkin.veinspracticesolution.com/assets/images/buttons/bahover.png"
              alt=""
              class="img-fluid btn-start img-top"
              id="backbtn"
            />
          </a>
        </div>

        <div class="card col" id="nextbtncard">
          <a href="javascript:void(0)">
            <img
              src="https://dev-checkin.veinspracticesolution.com/assets/images/buttons/pi.png"
              alt=""
              class="img-fluid btn-start"
              id="nextbtn"
            />
            <img
              @click="NextClick2()"
              src="https://dev-checkin.veinspracticesolution.com/assets/images/buttons/pihover.png"
              alt=""
              class="img-fluid btn-start img-top"
              id="nextbtn"
            />
          </a>
        </div>
      </div>
    </div>
  </section>

  <section
    v-show="thanks"
    id=""
    class="section active m-b-40"
    style="margin-top: 70px"
  >
    <div class="container form-container slide">
      <h3 class="text-center boldText">THANK YOU FOR VISITING VEINS</h3>
    </div>
  </section>
</template>


  
<script>
import axios from "axios";

export default {
  data() {
    return {
      paymentDue: true,
      paymentReceipt: false,
      thanks: false,
      nextBtn: false,
      loader: "",
      CreditCardInfo: {
        ownerId: 0,
        patientId: 0,
        practiceId: 0,
        pndx: 0,
        visitId: 0,
        cardHolderName: "",
        cardNumber: "",
        cardcvc: "",
        expiryDate: "",
        zip: "",
        amount: "",
        comment: "",
        localDate: "",
      },
      PaymentRequest: {
        PNDX: "",
        PatientId: 0,
        PracticeId: 0,
        OwnerId: 0,
        VisitId: 0,
        FirstName: "",
        LastName: "",
        Name: "",
        DOB: "",
        DOS: "",
        SentById: 0,
        SentBy: "",
        SentDate: "",
        Amount: 0,
        Notes: "",
        Attacments: "",
        ApiPresent: false,
      },
    };
  },
  methods: {
    loadinit() {
      var ownerPatientEncode = this.$route.query.RectPay;
      var ownerPatientDecode = JSON.parse(atob(ownerPatientEncode));
      this.getAxiosPayment(ownerPatientDecode);
    },
    async getAxiosPayment(Data) {
      const Url = this.SERVER + "/VNSPRAAPI/Payments/GetPaymentDue";
      await axios({
        method: "post",
        data: Data,
        url: Url,
      })
        .then((res) => {
         
          this.loader = this.$loading.show({
            // Optional parameters
            color: "#03a9f3",
          });
          debugger; // eslint-disable-line no-debugger
          const rp = res.data.data;
          if (res.data.status) {
            this.PaymentRequest.PNDX = rp.pndx;
            this.PaymentRequest.PatientId = rp.patientId;
            this.PaymentRequest.PracticeId = rp.practiceId;
            this.PaymentRequest.OwnerId = rp.ownerId;
            this.PaymentRequest.VisitId = rp.visitId;
            this.PaymentRequest.FirstName = rp.firstName;
            this.PaymentRequest.LastName = rp.lastName;
            this.PaymentRequest.Name = rp.name;
            this.PaymentRequest.DOB = rp.dobStr;
            this.PaymentRequest.DOS = rp.dosStr;
            this.PaymentRequest.SentById = rp.sentById;
            this.PaymentRequest.SentBy = rp.sentBy;
            this.PaymentRequest.SentDate = rp.sentDateStr;
            this.PaymentRequest.Amount = rp.amount;
            this.PaymentRequest.Notes = rp.notes;
            this.PaymentRequest.Attacments = rp.attachments;
            
              this.nextBtn = rp.apiPresent;
              if(rp.apiPresent == false)
              {
                 this.ShowError("This practice cannot collect payments online.");
              }
          } else {
            this.ShowError(res.data.message);
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => {
          this.loader.hide();
        });
    },
    BackClick() {
      this.paymentReceipt = false;
      this.paymentDue = true;
    },
    NextClick() {
      this.paymentDue = false;
      this.CreditCardInfo.ownerId = this.PaymentRequest.OwnerId;
      this.CreditCardInfo.visitId = this.PaymentRequest.VisitId;
      this.CreditCardInfo.patientId = this.PaymentRequest.PatientId;
      this.CreditCardInfo.pndx = this.PaymentRequest.PNDX;
      this.CreditCardInfo.amount = this.PaymentRequest.Amount;
      this.CreditCardInfo.practiceId = this.PaymentRequest.PracticeId;
      this.CreditCardInfo.localDate = new Date();
      this.paymentReceipt = true;
    },
    async NextClick2() {
      this.CreditCardInfo.cardNumber =
        this.CreditCardInfo.cardNumber.replaceAll("-", "");
      this.loader = this.$loading.show({
        // Optional parameters
        color: "#03a9f3",
      });
      const Url = this.SERVER + "/VNSPRAAPI/Payments/MakePaymentDuePatient";
      await axios({
        method: "post",
        data: this.CreditCardInfo,
        url: Url,
      })
        .then((res) => {
          this.loader.hide();
          debugger; // eslint-disable-line no-debugger
          const rp = res.data;
          if (rp.status) {
            this.paymentReceipt = false;
            this.thanks = true;
          } else {
            this.ShowError("Transaction failed! try later");
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => {
          this.loader.hide();
        });
    },
  },
  mounted() {
    this.loadinit();
  },
};
</script>

<style scoped>
.float-label-left {
  left: 10px;
}
</style>